import { ProductSummary } from "./../../product-modal/model/ProductSummary";
import { ProductModalSummary } from "src/features/products/model/ProductDetail";
import { HighlightedProduct } from "../model/HighlightedProduct";

export default function getSummaryFromProduct(
  data: HighlightedProduct | ProductModalSummary
): ProductSummary {
  let name = "",
    price = "",
    image = "",
    url = "",
    pk = -1,
    productDiscount = "";

  if ("omniweb_id" in data) {
    name = data.name;
    price = data.price;
    url = data.shop_url;
    pk = data.omniweb_id;
    image = data.imageUrl;
  }
  if ("productPk" in data) {
    name = data.productName;
    price = data.productPrice;
    url = data.productUrl;
    pk = data.productPk;
    image = data.productImage;
  }

  if (data?.productDiscount) {
    productDiscount = data.productDiscount;
  }

  return {
    productDiscount,
    name,
    price,
    image,
    url,
    pk,
  };
}
